import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { isNumber } from 'lodash';
import { useUserTestTasks } from 'src/hooks';
import { useAppDispatch } from '../../redux';

import { PageTransitionWrapper } from '../../components';
import { BackToTest } from './components/BackToTest';
import { PendingResults } from './components/PendingResults';
import SimulatedTTScoreInput from './components/SimulatedTTScoreInput';

import { getHackerRankResults } from 'src/redux/testTasks';

import {
  APP_ROUTES,
  HackerRankTestStatus,
  TEST_TASK_STATUS_REFRESH_TIME,
  simulatedTTString,
} from 'src/constants';

export const HackerRankTestTaskPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { currentTestTask } = useUserTestTasks();

  const [hackerRankTestStatus, setHackerRankTestStatus] =
    useState<HackerRankTestStatus | null>(null);

  const hasCurrentTestTask = !!currentTestTask;
  const isSimulatedTT = currentTestTask?.link?.startsWith(simulatedTTString);

  // Poll HackerRank test status until evaluated or no test task
  useEffect(() => {
    if (isSimulatedTT) return;

    let timeoutId: NodeJS.Timeout;

    const pollStatus = async () => {
      if (!hasCurrentTestTask) {
        navigate(`/${APP_ROUTES.APPLICATION_SUCCESS}`);
        return;
      }

      const res = await dispatch(getHackerRankResults(currentTestTask.id));
      if (getHackerRankResults.fulfilled.match(res)) {
        const status = isNumber(res.payload?.status)
          ? res.payload.status
          : null;
        setHackerRankTestStatus(status);

        if (status !== HackerRankTestStatus.Evaluated) {
          timeoutId = setTimeout(
            pollStatus,
            1000 * TEST_TASK_STATUS_REFRESH_TIME,
          );
        }
      }
    };

    pollStatus();

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [hasCurrentTestTask, isSimulatedTT, currentTestTask?.id]);

  return (
    <PageTransitionWrapper>
      {[HackerRankTestStatus.Invited, HackerRankTestStatus.Started].includes(
        hackerRankTestStatus!,
      ) ? (
        <BackToTest testLink={currentTestTask?.link || null} />
      ) : (
        <PendingResults />
      )}
      {isSimulatedTT && <SimulatedTTScoreInput />}
    </PageTransitionWrapper>
  );
};
